<p>{{ 'view-questionnaire-trainee-dialog.placeholder' | translate }}</p>

